module.exports = __webpack_public_path__ + "static/media/easypm-assurance.4fde736b.m4v";